/**
 * Module:	Common userpreferences
 * Title:	Static text
 */

import {tr} from '@alias_root/src/framework/ods/ods';

export const TC = {
	dialogTitle: tr(
		'A new password will be sent to you, enter your email address',
		'Ein neues Passwort wird an Sie gesendet. Geben Sie Ihre E-Mail-Adresse ein',
	),
	okButtonTitle: tr('Submit', 'Übernehmen'),
	// form
	labelEmail: tr('Your email address', 'Ihre E-Mail-Adresse'),
	successMessaage: tr(
		'A new password has successfully been sent to you ($1) and should arrive within a few minutes.',
		'Ein neues Passwort wurde erfolgreich an Sie ($1) versandt und sollte innerhalb der nächsten Minuten bei Ihnen sein.',
	),
	validateEmail: tr('Requires valid email address', 'Benötigt eine gültige E-Mail-Adresse'),
} as const;
